import React from 'react';
import PropTypes from 'prop-types';

const SvgDuplicate = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#ffffff';
    const strokeColor = active ? '#ffffff' : '#343A72';
    const color = active ? '#7AB3B3' : '#EAEBF0';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25" {...props}>
            <rect
                width="18.917"
                height="18.917"
                x="4.658"
                y=".625"
                fill={color}
                stroke={strokeColor}
                strokeWidth="1.25"
                rx="3.375"
            />
            <rect
                width="18.917"
                height="18.917"
                x=".625"
                y="4.658"
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                rx="3.375"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M6.722 14.117h6.722m-3.361 3.361v-6.722"
            />
        </svg>
    );
};

SvgDuplicate.propTypes = {
    active: PropTypes.bool,
};
SvgDuplicate.defaultProps = {
    active: false,
};

export default SvgDuplicate;
